module.exports = __webpack_public_path__ + "static/InfectedPersonsPrefecture_32.dot-59274c14f87ad45be62c34f02b0528ed.svg";